export const list = {
  list: {
    option: {
      focusBackground: '{primary.50}',
      focusColor: '{text.color}',
      selectedBackground: '{primary.100}',
      selectedColor: '{text.color}',
      selectedFocusBackground: '{primary.100}',
      selectedFocusColor: '{text.color}',
    },
  },
};
